import * as _ from 'lodash';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { FcpIconSVGSizes, IconNameMap } from 'fc-ui-components';

import { AvailableLanguage, getAppExternalLink, getAppLogo, getAppName } from 'helpers';
import { LanguageService } from 'shared/services';
@Component({
    selector: 'fc-signup-request',
    templateUrl: './signup-request.component.html',
    styleUrls: ['./signup-request.component.less'],
    standalone: false
})
export class SignupRequestComponent implements OnInit {
    public languageForm: FormGroup;
    public languages = [];
    public appInfo: {
        logo: {
            small: string;
            medium: string;
            original: string;
            smallWhite: string;
        };
        name: string;
        link: string;
    };

    iconNameMap = IconNameMap;
    fcpIconSVGSize = FcpIconSVGSizes;

    constructor(
        private formBuilder: FormBuilder,
        private languageService: LanguageService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.appInfo = {
            logo: getAppLogo(),
            name: getAppName(),
            link: getAppExternalLink()
        };

        const browserLanguage = this.languageService.getBrowserLanguage();
        this.languageForm = this.formBuilder.group({
            lang: { label: _.upperCase(browserLanguage), value: browserLanguage }
        });

        this.initLanguages();
    }

    logout() {
        this.router.navigate(['logout']);
    }

    private initLanguages() {
        const languageKeys = _.keys(AvailableLanguage);
        languageKeys.forEach((language) => {
            this.languages.push({
                label: _.upperCase(language),
                value: AvailableLanguage[language],
                action: () => {
                    this.languageService.use(AvailableLanguage[language]);
                    this.languageForm.patchValue({
                        lang: { label: _.upperCase(AvailableLanguage[language]), value: AvailableLanguage[language] }
                    });
                }
            });
        });
    }
}
